import { toWSDateString, WSPillProps } from "@wingspanhq/fe-component-library";
import {
  RequirementStatus,
  SignatureRequest
} from "@wingspanhq/wingspan-api-sdk";

import { selectorIsRequirementReadyToSignAsPayee } from "../../../../selectors/selectorIsRequirementReadyToSignAsPayee";
import {
  ContextItem,
  RequirementStatusViewProps,
  RequirementTableItemData
} from "../../../../types";

import { getSignerByRole, PAYER_SIGNER_ROLE } from "./getSignerByRole";

export const getSignaturePayeeRequirementStatus = (
  requirement: RequirementTableItemData,
  contextItem: ContextItem,
  signatureRequest: SignatureRequest | undefined
): RequirementStatusViewProps => {
  let pill: WSPillProps;
  let secondaryText: string | undefined;

  const isRequirementReadyToSignAsPayee =
    selectorIsRequirementReadyToSignAsPayee(requirement, signatureRequest);

  if (requirement.status === RequirementStatus.COMPLETED) {
    pill = {
      theme: "success",
      text: "Complete",
      icon: true
    };

    const completedAt =
      getSignerByRole(signatureRequest, PAYER_SIGNER_ROLE)?.signedAt ??
      signatureRequest?.events?.completedAt;

    secondaryText = completedAt
      ? toWSDateString(completedAt, "monthDayYear")
      : "";
  } else if (isRequirementReadyToSignAsPayee) {
    pill = {
      theme: "warning",
      text: "Action required",
      icon: true
    };
    secondaryText = "Awaiting your signature";
  } else {
    pill = {
      theme: "neutral",
      text: "Awaiting client",
      icon: "time"
    };
    secondaryText = "Awaiting client signature";
  }

  return {
    pill,
    secondaryText
  };
};
